import { BaseMapper } from '../shared/base.mapper';
import { App } from '../../types/admon/app.type';

export class AppMapper extends BaseMapper<App> {

}
